import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiurl } from "../Constants";

export const fetchTestimonial = createAsyncThunk(
  "testimonial/fetchtestimonial",
  async () => {
    const response = await axios.get(apiurl + "testimonial");
    return response.data.data;
  }
);

// Initial state
const initialState = {
  testimonial: [],
  loading: false,
  status: "idle",
  error: null,
};

const testimonialSlice = createSlice({
  name: "testimonial",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonial.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchTestimonial.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.testimonial = action.payload;
      })
      .addCase(fetchTestimonial.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default testimonialSlice.reducer;
